import apiClient from '@/services/AccountClient'

const state = () => ({
  ratesInfo: {},
  loading: false
})

const getters = {
  ratesInfo (state) {
    return state.ratesInfo
  }
}

const actions = {
  getRatesInfo ({ commit }) {
    commit('toggleLoading')

    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/currencies/rates'
    )
      .then(response => {
        commit('toggleLoading')
        commit('setRatesInfo', response.payload)
      })
  },
  toggleLoading ({ commit }) {
    commit('toggleLoading')
  }
}

const mutations = {
  setRatesInfo (state, ratesInfo) {
    state.ratesInfo = ratesInfo
  },
  toggleLoading (state) {
    state.loading = !state.loading
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
